import React, { useState, useEffect } from "react";
import './Header.css';
import RunningAdHeader from '../ClickaCook/RunningAdHeader'
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`cac-header ${isScrolled ? 'cac-header--scrolled' : ''}`}>
      <div className="cac-container">
        <nav className="cac-nav">
          {/* Logo Section */}
          <div className="cac-logo-section">
            <a href="#home" className="cac-logo" onClick={closeMenu}>
              <div className="cac-logo-icon">
                <i className="fas fa-utensils"></i>
              </div>
              <div className="cac-logo-text">
                <span className="cac-logo-main">ClickaCook</span>
                <span className="cac-logo-sub">Professional Chef Services</span>
              </div>
            </a>
          </div>
          <RunningAdHeader/>

          {/* Navigation Links */}
          <div className={`cac-nav-links ${isMenuOpen ? 'cac-nav-links--active' : ''}`}>
            <a href="#home" className="cac-nav-link" onClick={closeMenu}>
              <i className="cac-nav-icon fas fa-home"></i>
              <span>Home</span>
            </a>
            <a href="#chefs" className="cac-nav-link" onClick={closeMenu}>
              <i className="cac-nav-icon fas fa-user-tie"></i>
              <span>Chefs</span>
            </a>
            <a href="#how-it-works" className="cac-nav-link" onClick={closeMenu}>
              <i className="cac-nav-icon fas fa-cogs"></i>
              <span>How It Works</span>
            </a>
            <a href="#pricing" className="cac-nav-link" onClick={closeMenu}>
              <i className="cac-nav-icon fas fa-tag"></i>
              <span>Pricing</span>
            </a>
            <a href="#testimonials" className="cac-nav-link" onClick={closeMenu}>
              <i className="cac-nav-icon fas fa-comments"></i>
              <span>Testimonials</span>
            </a>
          </div>

          {/* Auth Buttons */}
          <div className="cac-auth-buttons">
            <button className="cac-btn cac-btn--outline">
              <i className="fas fa-sign-in-alt"></i>
              <span>Log In</span>
            </button>
            <button className="cac-btn cac-btn--primary">
              <i className="fas fa-user-plus"></i>
              <span>Sign Up</span>
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className={`cac-menu-toggle ${isMenuOpen ? 'cac-menu-toggle--active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="cac-menu-overlay" onClick={closeMenu}></div>
      )}
    </header>
  );
};

export default Header;